<p>pagamento-detail works!</p>
